import type { BetbyEnvironmentConfig } from '@app/core/environment-service';

/**
 * Betby BETA/TEST stack (integration phase of FAST_NEW_FRONT-6728). Wired into the DEV profiles
 * (dev, store-dev, local) AND — by host — into the `*.devfast.io` stands of the stage bundle
 * (betby-stack.util.ts): those stands run against the DEV backend, whose Betby integration is this
 * beta stack. The csgofast4 stagings and production run the PRODUCTION stack (betby-prod.config.ts).
 *
 * Caveat for authorized play: the player token must be signed against the SAME Betby environment
 * the widget is branded for — if the backend signs for a different stack than this config,
 * logged-in players get a handshake_fail (guests are unaffected).
 *
 * (Betby BETA OPERATOR id for support requests — not a widget option — is 2686276108583837698.)
 */
export const BETBY_BETA_CONFIG: BetbyEnvironmentConfig = {
  scriptUrl: 'https://ui.invisiblesport.com/bt-renderer.min.js',
  brandId: '2686276108583837703',
  themeName: 'csgofast',
  playerAuthEnabled: true,
};
